export const allProjects = [
  { id: -1, label: 'All' },
  { id: 1, label: 'ClassRoom' },
  { id: 2, label: 'Foundation' },
  { id: 3, label: 'Little Genie' },
  { id: 4, label: 'Speak Pro' },
];
